module.exports = class Features {
  constructor(user, token) {
    ; (this.user = user), (this.token = token)
  }

  /*
   ** Athena content features selection
   */
  getContentFeatures() {
    return [
      {
        title: 'Surveys List',
        feature: 'survey-list',
      },
      {
        title: 'Rewards & Recognition',
        feature: 'rewards-and-recognition',
      },
    ]
  }

  /*
   ** Athena function selection data
   */
  getActionFunctions() {
    return [
      { title: 'New Reward Gateway Link', function: 'rewardGatewayLink' },
      {
        title: 'Rewards Gateway Link',
        function: 'rgLink',
      },
      {
        title: 'Document Storage Link',
        function: 'dsLink',
      },
      {
        title: 'New System SSO Link',
        function: 'goToBenefitsHub',
      }
    ]
  }

  /*
   ** Rewards Gateway Link
   */
  async rgLink(params) {
    try {
      window.axios
        .post(
          `https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/icom-sso`,
          {
            userId: this.user.id,
          }
        )
        .then((response) => {
          let form = document.createElement('form')
          form.method = 'POST'
          form.action = 'https://www.ewagerewards.co.uk/autologin/login/'

          for (let key in response.data) {
            let temp = document.createElement('input')
            temp.name = key
            temp.value = response.data[key]
            form.appendChild(temp)
          }

          document.body.appendChild(form)

          form.submit()
        })
    } catch (error) {
      console.log(error)
    }
  }

  async rewardGatewayLink(params) {
    try {
      const response = await window.axios.post(`/reward-gateway`, {
        user: this.user,
      })
      console.log(response)
      let form = document.createElement('form')
      form.method = 'POST'
      form.action = response.data.url

      let temp = document.createElement('input')
      temp.name = 'SAMLResponse'
      temp.value = response.data.saml
      form.appendChild(temp)

      document.body.appendChild(form)

      form.submit()
    } catch (error) {
      console.error(error)
      return error
    }
  }

  /*
   ** Document Storage Link
   */
  async dsLink() {
    try {
      const response = await axios.post(`/switch-system`, {
        clientId: this.user.client_id,
        system: 'documents',
        accessToken: this.token,
      })

      window.location.replace(`http://${response.data}`, '_blank')
    } catch (error) {
      console.log(error)
    }
  }

  /*
   ** New System SSO Link
   */

  async goToBenefitsHub() {
    const user = this.user

    if (!user || !user.email || !user.forename || !user.surname || !user.id) {
      console.error('User info is incomplete')
      return
    }

    try {
      const res = await fetch('https://external-sso.matrixbenefits.co.uk/api/sign-sso-token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: user.email,
          forename: user.forename,
          surname: user.surname,
          id: user.id,
          platform_id: '59f7c189-9515-4dcb-a0cf-3a1dc9e0f2c0'
        }),
      })

      const data = await res.json()

      if (!res.ok) {
        console.error('Failed to generate token:', data.error)
        return
      }

      window.location.replace(data.redirectUrl)
    } catch (err) {
      console.error('Error requesting SSO token:', err)
    }
  }
}
